import * as z from "zod";

export const getSpsCommerceIntegrationStatus = {
  name: "getSpsCommerceIntegrationStatus" as const,
  input: z.object({ installAttemptNonce: z.string().uuid().optional() }),
  output: z.object({
    isConnected: z.boolean(),
    installAttemptStatus: z
      .enum(["completed", "expired", "pending"])
      .optional(),
  }),
};
